import TransitionCollapse from 'Components/TransitionCollapse'

export default {
  components: {
    TransitionCollapse,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
    transitionDuration: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: this.expanded,
      transitioning: false,
    }
  },
  methods: {
    toggleTransitionCollapse() {
      if (this.transitioning) return
      this.transitioning = true
      this.visible = !this.visible
      setTimeout(() => {
        this.transitioning = false
      }, this.durationCalculated)
    },
  },
  computed: {
    durationCalculated() {
      return this.transitionDuration + this.transitionDuration / 10
    },
  },
}
